<!-- BEGIN: Subheader -->
<div class="m-subheader ">
    <div class="d-flex align-items-center">
        <div class="mr-auto">
            <h3 class="m-subheader__title m-subheader__title--separator">Nueva Categoría</h3>
            <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
                <li class="m-nav__item m-nav__item--home">
                    <a [routerLink]="''" class="m-nav__link m-nav__link--icon">
                        <i class="m-nav__link-icon la la-home"></i>
                    </a>
                </li>
                <li class="m-nav__separator">-</li>
                <li class="m-nav__item">
                    <a [routerLink]="'/categories'" class="m-nav__link">
                        <span class="m-nav__link-text">Categorías</span>
                    </a>
                </li>
                <li class="m-nav__separator">-</li>
                <li class="m-nav__item">
                    <a *ngIf="category.id == null" [routerLink]="'/categories/create'" class="m-nav__link">
                        <span class="m-nav__link-text">Crear Categoría</span>
                    </a>
                    <a *ngIf="category.id != null" [routerLink]="['/categories/edit', category.id]" class="m-nav__link">
                        <span class="m-nav__link-text">Editar Categoría</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>

<div class="m-content">
    <div class="row">
        <div class="col-md-12">
            <!--begin::Portlet-->
            <div class="m-portlet m-portlet--mobile">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <h3 *ngIf="category.id == null" class="m-portlet__head-text">
                                Crear Categoría
                            </h3>
                            <h3 *ngIf="category.id != null" class="m-portlet__head-text">
                                Editar Categoría - {{category.name}}
                            </h3>
                        </div>
                    </div>
                    <div class="m-portlet__head-tools">
                        <ul class="m-portlet__nav">
                            <li class="m-portlet__nav-item">
                                <a [routerLink]="'/categories'"
                                   class="m-portlet__nav-link btn btn-lg btn-secondary m-btn m-btn--outline-2x m-btn--air m-btn--icon m-btn--icon-only m-btn--pill  m-dropdown__toggle">
                                    <i class="flaticon-reply"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <form [formGroup]="form" (ngSubmit)="sendForm()" class="m-form m-form--label-align-right">
                    <div class="m-portlet__body">
                        <div class="m-form__section m-form__section--first">
                            <div class="form-group m-form__group row">
                                <div class="col-10 ml-auto">
                                    <h3 class="m-form__section">Información de la Categoría</h3>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Nombre:</label>
                                <div class="col-lg-6">
                                    <input formControlName="name" class="form-control m-input" placeholder="Nombre"
                                           [ngClass]="{ 'is-invalid': submitted && f.name.errors }">
                                    <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                        <div *ngIf="f.name.errors.required">Nombre obligatorio</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Foto:</label>
                                <div class="col-lg-6">
                                    <div class="custom-file">
                                        <input type="file" class="custom-file-input" id="customFile"
                                               accept="image/x-png,image/jpg,image/jpeg"
                                               (change)="onSelectFile($event)">
                                        <label class="custom-file-label" for="customFile">{{pathFile1}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Foto 2:</label>
                                <div class="col-lg-6">
                                    <div class="custom-file">
                                        <input type="file" class="custom-file-input" id="customFile_2"
                                               accept="image/x-png,image/jpg,image/jpeg"
                                               (change)="onSelectFileTwo($event)">
                                        <label class="custom-file-label" for="customFile_2">{{pathFile2}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Foto 3:</label>
                                <div class="col-lg-6">
                                    <div class="custom-file">
                                        <input type="file" class="custom-file-input" id="customFile_3"
                                               accept="image/x-png,image/jpg,image/jpeg"
                                               (change)="onSelectFileThree($event)">
                                        <label class="custom-file-label" for="customFile_3">{{pathFile3}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Estado:</label>
                                <div class="col-lg-6">
                                    <select formControlName="status" class="form-control m-input"
                                            [ngClass]="{ 'is-invalid': submitted && f.status.errors }">
                                        <option value="1">Activo</option>
                                        <option value="0">Inactivo</option>
                                    </select>
                                    <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                        <div *ngIf="f.status.errors.required">Estado obligatorio</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Principal:</label>
                                <div class="col-lg-6">
                                    <select formControlName="principal" class="form-control m-input"
                                            [ngClass]="{ 'is-invalid': submitted && f.principal.errors }">
                                        <option value="1">Si</option>
                                        <option value="0">No</option>
                                    </select>
                                    <div *ngIf="submitted && f.principal.errors" class="invalid-feedback">
                                        <div *ngIf="f.principal.errors.required">Debe seleccionar una opción</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Marcas:</label>
                                <div class="col-lg-4">
                                    <select class="form-control m-input" (change)="onSelectBrand($event)">
                                        <option selected>Seleccione una marca</option>
                                        <option [value]="item.id" *ngFor="let item of brands">{{ item.name }}</option>
                                    </select>
                                </div>
                                <div class="col-lg-2">
                                    <button type="button" (click)="addBrand()"
                                            class="btn btn-primary" style="height: 100%;width: 100%;padding: 0;">
                                        + Agregar marca
                                    </button>
                                </div>
                            </div>
                            <div *ngIf="brands_data.length > 0" class="form-group m-form__group row">
                                <div class="col-lg-2"></div>
                                <div class="col-lg-6">
                                    <div class="info_data" *ngFor="let item of brands_data">
                                        <div class="content_data">
                                            <svg (click)="deleteBrand(item.id)" xmlns="http://www.w3.org/2000/svg"
                                                 width="16" height="16" fill="currentColor" class="bi bi-x delete_data"
                                                 viewBox="0 0 16 16">
                                                <path
                                                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                            </svg>
                                            <p>{{ item.name }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="m-form__seperator m-form__seperator--dashed m-form__seperator--space-2x"></div>
                            <div class="form-group m-form__group row">
                                <div class="col-10 ml-auto">
                                    <h3 class="m-form__section">SEO</h3>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Título:</label>
                                <div class="col-lg-6">
                                    <input formControlName="title_seo" class="form-control m-input" placeholder="Título"
                                           [ngClass]="{ 'is-invalid': submitted && f.title_seo.errors }">
                                    <div *ngIf="submitted && f.title_seo.errors" class="invalid-feedback">
                                        <div *ngIf="f.title_seo.errors.required">Título obligatorio</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Descripción:</label>
                                <div class="col-lg-6">
                                    <textarea formControlName="description_seo" class="form-control m-input" rows="3"
                                              placeholder="Descripción"
                                              [ngClass]="{ 'is-invalid': submitted && f.description_seo.errors }"></textarea>
                                    <div *ngIf="submitted && f.description_seo.errors" class="invalid-feedback">
                                        <div *ngIf="f.description_seo.errors.required">Descripción obligatorio</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Keywords:</label>
                                <div class="col-lg-6">
                                    <input formControlName="keywords" class="form-control m-input" placeholder="Keywords"
                                           [ngClass]="{ 'is-invalid': submitted && f.keywords.errors }">
                                    <div *ngIf="submitted && f.keywords.errors" class="invalid-feedback">
                                        <div *ngIf="f.keywords.errors.required">Keywords obligatorio</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__foot m-portlet__foot--fit">
                        <div class="m-form__actions">
                            <div class="row">
                                <div class="col-2">
                                </div>
                                <div class="col-7">
                                    <button type="submit" [disabled]="loading"
                                            class="btn btn-accent m-btn m-btn--air m-btn--custom"
                                            [ngClass]="{'m-loader m-loader--light m-loader--right': loading}">
                                        Guardar Cambios
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
